const TOKYO_TIME_ZONE = 'Asia/Tokyo';

interface TokyoDateParts {
  year: number;
  month: number;
  day: number;
  hour: number;
  minute: number;
}

const partsFormatter = new Intl.DateTimeFormat('ja-JP', {
  timeZone: TOKYO_TIME_ZONE,
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

function tokyoParts(value: string | number | Date): TokyoDateParts | null {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const values = Object.fromEntries(
    partsFormatter.formatToParts(date).map((part) => [part.type, Number(part.value)]),
  );
  if (![values.year, values.month, values.day, values.hour, values.minute].every(Number.isFinite)) return null;
  return values as unknown as TokyoDateParts;
}

export function formatCouponEndAt(value: string): string {
  const parts = tokyoParts(value);
  if (!parts) return '期限は楽天ページでご確認ください';
  return `${parts.month}月${parts.day}日 ${String(parts.hour).padStart(2, '0')}:${String(parts.minute).padStart(2, '0')}まで`;
}

export function formatDeadlineHint(endAt: string, now: Date = new Date()): string | null {
  const end = tokyoParts(endAt);
  const current = tokyoParts(now);
  if (!end || !current) return null;
  const endDay = Date.UTC(end.year, end.month - 1, end.day);
  const currentDay = Date.UTC(current.year, current.month - 1, current.day);
  const days = Math.round((endDay - currentDay) / 86_400_000);
  if (days < 0) return null;
  if (days === 0) return '本日まで';
  return `あと${days}日`;
}

export { TOKYO_TIME_ZONE };
